import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { ConnectionState, NetworkService } from '@igo2/core/network';

import { Observable } from 'rxjs';

import { GeoDB } from '../geoDB';

export type ResponseType = 'arraybuffer' | 'json' | 'text' | 'xml' | 'blob';
export interface SimpleGetOptions {
  responseType: ResponseType;
  withCredentials?: boolean;
}
@Injectable()
export class GeoNetworkService {
  private http = inject(HttpClient);
  private networkService = inject(NetworkService);

  private networkOnline = true;
  constructor() {
    this.networkService.currentState().subscribe((state: ConnectionState) => {
      this.networkOnline = state.connection;
    });
  }

  get(url: string, simpleGetOptions: SimpleGetOptions): Observable<any> {
    if (window.navigator.onLine && this.networkOnline) {
      return this.getOnline(url, simpleGetOptions);
    }
    return this.getOffline(url);
  }

  private getOnline(
    url: string,
    simpleGetOptions: SimpleGetOptions
  ): Observable<any> {
    let request;
    switch (simpleGetOptions.responseType) {
      case 'arraybuffer':
        request = this.http.get(url, {
          responseType: 'arraybuffer',
          withCredentials: simpleGetOptions.withCredentials
        });
        break;
      case 'text':
        request = this.http.get(url, {
          responseType: 'text',
          withCredentials: simpleGetOptions.withCredentials
        });
        break;
      case 'json':
        request = this.http.get(url, {
          responseType: 'json',
          withCredentials: simpleGetOptions.withCredentials
        });
        break;
      default:
        request = this.http.get(url, {
          responseType: 'blob',
          withCredentials: simpleGetOptions.withCredentials
        });
        break;
    }
    return request;
  }

  private getOffline(url: string): Observable<object | Blob> {
    const geoDB = new GeoDB();
    return geoDB?.get(url);
  }

  public isOnline() {
    return this.networkOnline && window.navigator.onLine;
  }
}
